import type { ClientItemId } from 'owa-client-ids';

export const getReadRibbonId = (
    baseId: number | string,
    itemId?: ClientItemId
): number | string => {
    return itemId ? `${baseId}_${itemId.Id}` : baseId;
};
